module.exports = __webpack_public_path__ + "img/icon_position_blue.f703f5c8.svg";